import { createModel } from '@rematch/core';
import global from 'global';
import request from 'request';

const initialValue: global.contextApplicationCollateral = {
  pending: false,
  data: null,
};

const applicationCollateral = createModel()({
  state: initialValue as global.contextApplicationCollateral,
  reducers: {
    START_PENDING(state) {
      return { ...state, pending: true };
    },
    STOP_PENDING(state) {
      return { ...state, pending: false };
    },
    SET(state, payload: global.applicationCollateral) {
      if (JSON.stringify(state.data) === JSON.stringify(payload)) return state;
      else return { ...state, data: payload };
    },
    REMOVE() {
      return initialValue;
    },
  },
  effects: (dispatch) => ({
    async FETCH_APPLICATION_BY_ID(id) {
      if (isNaN(Number(id))) {
        dispatch.applicationCollateral.REMOVE();
        return;
      }
      dispatch.applicationCollateral.START_PENDING();
      const response = await request.get('applications_gold/' + id);
      const data = await response.data;
      dispatch.applicationCollateral.STOP_PENDING();
      dispatch.applicationCollateral.SET(data);
    },
  }),
});

export default applicationCollateral;
